import { Icon } from '@design/components/icon/Icon';
import { NumericalCellValueStyle } from '@helpers/utils/table/table';
import { TooltipContainer } from '@terminal/components/tooltip-container/TooltipContainer';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

import styles from './RankMovement.module.scss';

const colors = {
  [NumericalCellValueStyle.Positive]: 'var(--viz-bullish)',
  [NumericalCellValueStyle.Negative]: 'var(--viz-bearish)',
  [NumericalCellValueStyle.Neutral]: 'var(--text-soft)',
};

interface RankMovementProps {
  change: number;
}

export const RankMovement = ({ change }: RankMovementProps) => {
  const { t } = useTranslation(['widget']);
  const hasMovement = change !== 0;
  const isPositive = change > 0;
  const count = Math.abs(change);

  const tooltipLabel = !hasMovement
    ? t('widget:assetOverview.knowledgeGraph.rankMovement.none')
    : isPositive
      ? t('widget:assetOverview.knowledgeGraph.rankMovement.up', { count })
      : t('widget:assetOverview.knowledgeGraph.rankMovement.down', { count });

  const color = !hasMovement
    ? colors[NumericalCellValueStyle.Neutral]
    : isPositive
      ? colors[NumericalCellValueStyle.Positive]
      : colors[NumericalCellValueStyle.Negative];

  return (
    <TooltipContainer label={tooltipLabel} placement="top">
      <span className={styles.root} style={{ color }}>
        (
        {hasMovement ? (
          <>
            <Icon
              className={clsx(styles.icon, {
                [styles.positive]: isPositive,
                [styles.negative]: !isPositive,
              })}
              size={12}
              iconName={isPositive ? 'CaretUp' : 'CaretDown'}
              aria-hidden
            />
            <span>{count}</span>
          </>
        ) : (
          <span>—</span>
        )}
        )
      </span>
    </TooltipContainer>
  );
};
